export default __webpack_public_path__ + "static/media/active_product_ico.955c63b6.svg";